export default __webpack_public_path__ + "static/media/illustration-recruit-2-m@2x.79e72ed4.webp";